import ProductPropertiesQueryInformation from "../../interfaces/ProductProperties/ProductPropertiesQueryInformation";
import requestProvider from "../RequestProvider/RequestProvider";

/**
 * Provider for different http requests to load product data
 */
export class ProductProvider {

    // INFO: This function can be expanded (copy + paste) to load more date from the solr
    /**
     * This function fetches the projectPdorductId from the SolR for a product. According to the isTestProduct, it uses the shopTestProduictId_s or 
     * the shopProductId_s to find the product data in the SolR
     * @param magicNumber The magic Number of a product
     * @param isTestProduct determine of the given product is a test product or not
     * @returns a promise with the product information from the product with the given magicNumber
     */
    async getProjectProductIdFromSolr(magicNumber: string, isTestProduct: boolean): Promise<number> {
        const baseUrl = isTestProduct
            ? '/delivery-service/select/de?q=shopTestProductId_s:'
            : '/delivery-service/select/de?q=shopProductId_s:';
        const fieldListQuery = '&fl=projectProductId_i'
        const url = baseUrl + magicNumber + fieldListQuery;
        const queryInformation = await requestProvider.getData(url);
        // console.log('getProjectProductIdFromSolr()', magicNumber, queryInformation);
        return queryInformation.response.docs[0]?.projectProductId_i || undefined;
    }

    /**
     * This function fetches the test product properties from the SolR for a product
     * @param magicNumber The magic Number of a product
     * @returns a promise with the product information from the product with the given magicNumber
     */
    async getTestProductMagicNumberFromSolr(magicNumber: string): Promise<string> {
        const baseUrl = '/delivery-service/select/de?q=shopProductId_s:';
        const fieldListQuery = '&fl=shopTestProductId_s'
        const url = baseUrl + magicNumber + fieldListQuery;
        const queryInformation = await requestProvider.getData(url);
        // console.log('getTestProductMagicNumberFromSolr()', magicNumber, queryInformation);
        return queryInformation.response.docs[0]?.shopTestProductId_s || undefined;
    }

    async getProductMagicNumberByTestProductFromSolr(magicNumber: string): Promise<string> {
        // console.log('getProductMagicNumberByTestProductFromSolr()', magicNumber);
        const baseUrl = '/delivery-service/select/de?q=shopTestProductId_s:';
        // const fieldListQuery = '&fl=shopTestProductId_s'
        const fieldListQuery = '';
        const url = baseUrl + magicNumber + fieldListQuery;
        const queryInformation = await requestProvider.getData(url);
        // console.log('getProductMagicNumberByTestProductFromSolr()', magicNumber, queryInformation);
        return queryInformation.response.docs[0]?.shopProductId_s || undefined;
    }

    /**
     * This function fetches the product information from the SolR for a product
     * @param magicNumber The magic Number of a product
     * @param isTestProduct determine of the given product is a test product or not
     * @returns a promise with the product information from the product with the given magicNumber
     * @see function getProductInformationFromQuery
     */
    async getProductInformationFromSolr(magicNumber?: string, isTestProduct?: boolean): Promise<ProductPropertiesQueryInformation> {
        const baseUrl = isTestProduct
            ? '/delivery-service/select/de?q=shopTestProductId_s:'
            : '/delivery-service/select/de?q=shopProductId_s:'
        const fieldListQuery = '&fl=IN_NAME,imageAlt_s,image_s,IN_LINK'
        const url = baseUrl + magicNumber + fieldListQuery;
        const queryInformation = await requestProvider.getData(url);
        // console.log('getProductInformationFromSolr()', magicNumber, isTestProduct, queryInformation);
        return {
            title: queryInformation.response.docs[0]?.IN_NAME as string || '',
            imageAlt: queryInformation.response.docs[0]?.imageAlt_s as string || '',
            imageSrc: queryInformation.response.docs[0]?.image_s as string || '',
            href: (queryInformation.response.docs[0]?.IN_LINK as string) || undefined,
        } as ProductPropertiesQueryInformation;
    }

}

const productProvider = new ProductProvider();
export default productProvider;
